import { analiticaInstance } from '@payments-checkout/shared/plugins/analitica/analitica.configs';

export const analiticaUsePaymentEvents = analiticaInstance.eventFactory(
  'Checkout v3',
  {
    recaptcha: {
      /**
       * @analitica When recpatcha is ready to execute
       */
      onReady: () => ({
        label: 'checkout v3 - recaptcha v3 ready',
      }),
      /**
       * @analitica When recpatcha returns a error on generate token
       */
      onExecuteError: () => ({
        label: 'checkout v3 - recaptcha v3 execute error',
      }),
      /**
       * @analitica When recpatcha returns a valid token
       */
      onExecuteSuccess: () => ({
        label: 'checkout v3 - recaptcha v3 execute success',
      }),
    },
  }
);
